// Build-time tenant config catalog.  Selection priority:
//
//   1. `REACT_APP_TENANT` env var (set at build time) — useful for
//      shipping a per-customer build, and for dev/staging instances
//      that want a different brand without backend coordination.
//   2. Backend-supplied tenant info (the existing `loadTenant` thunk
//      in `features/tenant`) — merges its `primary_color`, `logo`,
//      `organization_name`, `*_term` fields on top of the static
//      defaults at runtime via `TenantThemeProvider`.
//   3. The `default` tenant in this directory — Outdoorlink branding.
//
// To add a new tenant: drop a `<id>.json` file in this directory
// following the shape of `default.json`, then deploy with
// `REACT_APP_TENANT=<id>` set in the build environment.

import defaultTenant from './default.json';

// Registry — add new tenants here as `require()` so webpack
// bundles them.  Keep this list short; large catalogs should move
// to dynamic import to avoid bloating the bundle.
const REGISTRY = {
  default: defaultTenant,
};

// `process.env.REACT_APP_TENANT` is replaced at build time by webpack's
// DefinePlugin (see webpack.config.dev.js / webpack.config.prod.js).
// The `typeof process` guard prevents a runtime ReferenceError on the
// off chance this module gets evaluated in a context where the
// DefinePlugin replacement didn't run (tests, SSR, an external host).
const readEnvTenantId = () => {
  try {
    if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_TENANT) {
      return process.env.REACT_APP_TENANT;
    }
  } catch {
    // ignore
  }
  return null;
};

const getTenantId = () => {
  const envId = readEnvTenantId();
  if (envId && REGISTRY[envId]) return envId;
  if (envId) {
    console.warn(`[tenant] REACT_APP_TENANT="${envId}" not found in registry; falling back to default`);
  }
  return 'default';
};

export const getBuildTimeTenant = () => REGISTRY[getTenantId()];
